import { ProfissionaisScreen } from "@/screens/recursos/profissionais";

/** Thin wrapper — toda lógica fica em screens/recursos/profissionais */
export function ProfissionaisPage() {
  return <ProfissionaisScreen />;
}
